import _toConsumableArray from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _assertThisInitialized from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _classCallCheck from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _ExchangeEndpoint;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import dayjs from 'dayjs';
import { TokenlonEnv } from "../../constants/env";
import { API_ROOT_DOMAIN } from "../../constants/rootDomain";
import { RPC } from "./rpc"; // @todo 需要讨论这里是用 env 还是 chainId

export var ExchangeEndpoint = (_ExchangeEndpoint = {}, _defineProperty(_ExchangeEndpoint, TokenlonEnv.local, 'https://exchange.imdev.works'), _defineProperty(_ExchangeEndpoint, TokenlonEnv.development, 'https://exchange.imdev.works'), _defineProperty(_ExchangeEndpoint, TokenlonEnv.staging, 'https://exchange.imstaging.works'), _defineProperty(_ExchangeEndpoint, TokenlonEnv.production, 'https://exchange.tokenlon.im'), _ExchangeEndpoint);
export var ExchangeRPC = /*#__PURE__*/function (_RPC) {
  _inherits(ExchangeRPC, _RPC);

  var _super = _createSuper(ExchangeRPC);

  function ExchangeRPC() {
    _classCallCheck(this, ExchangeRPC);

    return _super.call(this, {
      envEndpoints: ExchangeEndpoint
    });
  }

  _createClass(ExchangeRPC, [{
    key: "getMobileAppConfig",
    value: function getMobileAppConfig() {
      return this.rpc('/rpc', 'tokenlon.getMobileAppConfig');
    }
  }]);

  return ExchangeRPC;
}(RPC);
export var MarketRPC = /*#__PURE__*/function (_RPC2) {
  _inherits(MarketRPC, _RPC2);

  var _super2 = _createSuper(MarketRPC);

  function MarketRPC() {
    var _this;

    _classCallCheck(this, MarketRPC);

    _this = _super2.call(this, {
      endpoint: "https://api.".concat(API_ROOT_DOMAIN, "/v1/market")
    });

    _defineProperty(_assertThisInitialized(_this), "requestPool", new Map());

    return _this;
  }

  _createClass(MarketRPC, [{
    key: "getMarketPrice",
    value: function getMarketPrice() {
      var _this2 = this;

      var tokensAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var chainId = arguments.length > 1 ? arguments[1] : undefined;
      var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'USD';
      if (!tokensAddress || !tokensAddress.length) return Promise.resolve([]);
      var key = [].concat(_toConsumableArray(tokensAddress), [chainId, currency]).join();
      var requestInPool = this.requestPool.get(key);

      if (requestInPool) {
        if (requestInPool.isPending) {
          return requestInPool.p;
        }

        if (dayjs().diff(requestInPool.timestamp) < 500) {
          return requestInPool.p;
        }

        this.requestPool["delete"](key);
      }

      var params = tokensAddress.map(function (address) {
        return chainId ? {
          caip2: "eip155:".concat(chainId),
          address: address,
          showOption: 'always'
        } : {
          chainType: 'ETHEREUM',
          showOption: 'always',
          address: address
        };
      });
      if (!params.length) return Promise.resolve([]);
      var p = this.rpc('/', 'market.getPrices', params, {
        headers: {
          'X-CURRENCY': currency
        }
      }).then(function (res) {
        try {
          var r = _this2.requestPool.get(key);

          if (r) r.isPending = false;
        } catch (error) {// ignore
        }

        return res;
      })["catch"](function (error) {
        try {
          var r = _this2.requestPool.get(key);

          if (r) r.isPending = false;
        } catch (error) {// ignore
        }

        throw error;
      });
      this.requestPool.set(key, {
        isPending: true,
        p: p,
        timestamp: +new Date()
      });
      return p;
    }
  }]);

  return MarketRPC;
}(RPC);
export var exchangeRpc = new ExchangeRPC();
export var marketRpc = new MarketRPC();
export default exchangeRpc;